/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationControllerFindWebNewsById200ResponseDataCompaniesInner } from './publicationControllerFindWebNewsById200ResponseDataCompaniesInner';
import { PublicationControllerFindWebNewsById200ResponseDataPublicationDetailsInner } from './publicationControllerFindWebNewsById200ResponseDataPublicationDetailsInner';


export interface PublicationControllerFindWebNewsById200ResponseData { 
    id?: string;
    name?: string;
    description?: string;
    coverPhotoUrl?: string;
    fileUrl?: string;
    externalUrl?: string;
    webPublishedOn?: string;
    createdOn?: string;
    companies?: Array<PublicationControllerFindWebNewsById200ResponseDataCompaniesInner>;
    publicationDetails?: Array<PublicationControllerFindWebNewsById200ResponseDataPublicationDetailsInner>;
}

